import React, { useEffect, useState } from 'react';
import {
    Routes,
    Route,
    useLocation
} from "react-router-dom";
import Minibar from '../../../components/navbar/Minibar';
import StandingAlarmPage from './StandingAlarm';
import HistoricalAlarmPage from './HistoricalAlarm';
import './AlarmEvent.css'

function Document(props) {
    const location = useLocation();
    const [data_uioption, setData_uioption] = useState({});
    const [data_alarmevent_standing, setData_alarmevent_standing] = useState([])

    useEffect(() => {
        if (props.data_uioption !== null) {
            if (props.data_uioption.device_selector !== null && props.data_uioption.device_selector !== undefined) {
                setData_uioption(props.data_uioption)
            }
        }
    }, [props.data_uioption]);

    useEffect(() => {
        if (props.data_alarmevent_standing !== undefined) {
            setData_alarmevent_standing(props.data_alarmevent_standing)
        }
    }, [props.data_alarmevent_standing]);

    const [submenu_mode, setSubmenu_mode] = useState('realtimeae');
    const [submenu_root, setSubmenu_root] = useState('Realtime A & E');

    useEffect(() => {
        if (location.pathname.search("/alarmevent/realtimeae") > -1) {
            setSubmenu_mode('realtimeae')
            setSubmenu_root('Realtime A & E')
        }
        if (location.pathname.search("/alarmevent/historicalae") > -1) {
            setSubmenu_mode('historicalae')
            setSubmenu_root('Historical A & E')
        }
    }, [location]);

    return (
        <section id="content" className="content">
            <Minibar
                main_root={"Alarm & Event System"}
                submenu_root={submenu_root}
                systemtime={props.data_systemdatetime}
            />
            <div className="content__boxed d-md-flex h-100">
                <div className="content__wrap order-2 flex-fill min-w-0">
                    <Routes>
                        <Route path="/realtimeae" element={
                            <StandingAlarmPage
                                systemtime={props.data_systemdatetime}
                                server_update={props.server_update}
                                permitdata={props.permitdata}
                                data_alarmevent_standing={data_alarmevent_standing}
                                callback_backcenter={() => { props.callback_backcenter() }}
                            ></StandingAlarmPage >} />
                        <Route path="/historicalae" element={
                            <HistoricalAlarmPage
                                systemtime={props.data_systemdatetime}
                                permitdata={props.permitdata}
                                data_uioption={data_uioption}
                                callback_backcenter={() => { props.callback_backcenter() }}
                            ></HistoricalAlarmPage >} />
                    </Routes>
                </div>
            </div>
        </section>

    )
}
export default Document